import { InputSwitchModule } from 'primeng/inputswitch';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';

@Component({
  selector: 'app-helpdesk',
  templateUrl: './helpdesk.component.html',
  styleUrls: ['./helpdesk.component.scss']
})
export class HelpdeskComponent implements OnInit {

  isSubmitted = false;
  applicationId: any = null;
  userID: any;

  constructor(
    public router: Router, 
    private messageService: MessageService, 
    private route: ActivatedRoute,
    private activityRecordService: ActivityRecordService
    ) { }

  ngOnDestroy(): void {
    console.log("Step 2")
  }

  ngOnInit(): void {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'Application Status', '', new Date(), 'Success');
  }

  getApplicationStatus() {
    if (!this.applicationId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! Application ID cant be null.',
      });
      return;
    }
    console.log("Step 1")
    // this.isSubmitted = false;
    this.ngOnDestroy();
    console.log("Step 3")
    console.log("Step 4")
   // this.router.navigate(['helpdesk', 'home', this.applicationId]);
   if (((this.router.url.startsWith('/helpdesk'))))
   {
     this.router.navigate(['helpdesk', 'home', this.applicationId]);
   }
   else if((this.router.url.startsWith('/xen'))){
    this.router.navigate(['xen', 'helpdesk', this.applicationId]);
   }
   else if((this.router.url.startsWith('/cao'))){
    this.router.navigate(['cao', 'helpdesk', this.applicationId]);
   }
   else{
    this.router.navigate(['department', 'helpdesk', this.applicationId]);
   }
    this.isSubmitted = true;
    console.log("Step 5")
  }

}